import { useState } from "react";
import { faqs } from "@/mocks/guaData";

export default function Faq() {
  const [open, setOpen] = useState<number | null>(0);

  const schema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: faqs.map((f) => ({
      "@type": "Question",
      name: f.q,
      acceptedAnswer: { "@type": "Answer", text: f.a },
    })),
  };

  return (
    <section id="faq" className="scroll-mt-20 bg-background-50 py-12 md:py-16">
      <script type="application/ld+json">{JSON.stringify(schema)}</script>
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="grid gap-10 lg:grid-cols-[1fr_1.6fr] lg:gap-16">
          <div>
            <span className="inline-flex items-center gap-1.5 rounded-full bg-secondary-100 px-3 py-1 text-xs font-semibold text-secondary-900">
              常见问题 · FAQ
            </span>
            <h2 className="mt-3 font-heading text-3xl text-foreground-900 md:text-4xl">
              关于呱呱，你想知道的都在这
            </h2>
            <p className="mt-4 text-sm leading-relaxed text-foreground-600 md:text-base">
              从内容来源到投稿方式，我们整理了几个被问到最多的问题。如果还有疑问，欢迎通过页尾的投稿表单告诉我们。
            </p>
            <div className="mt-6 rounded-2xl border border-primary-200 bg-primary-50 p-4">
              <p className="flex items-start gap-2 text-sm text-primary-800">
                <i className="ri-lightbulb-line mt-0.5 text-lg"></i>
                <span>
                  小提示：想找某条具体的神回复或名场面，可以直接用顶部搜索框，或回到「吃瓜神回复」专区按频道筛选。
                </span>
              </p>
            </div>
          </div>

          <div className="space-y-3">
            {faqs.map((f, i) => {
              const active = open === i;
              return (
                <div
                  key={f.q}
                  className={`overflow-hidden rounded-2xl border transition-colors ${
                    active ? "border-primary-300 bg-background-100" : "border-background-200 bg-background-100/50"
                  }`}
                >
                  <button
                    type="button"
                    onClick={() => setOpen(active ? null : i)}
                    aria-expanded={active}
                    className="flex w-full items-center justify-between gap-3 px-5 py-4 text-left"
                  >
                    <h3 className="text-[15px] font-medium text-foreground-800">{f.q}</h3>
                    <i
                      className={`shrink-0 text-lg text-primary-600 transition-transform duration-300 ${
                        active ? "ri-subtract-fill" : "ri-add-fill"
                      }`}
                    ></i>
                  </button>
                  <div
                    className={`grid transition-all duration-300 ${
                      active ? "grid-rows-[1fr] opacity-100" : "grid-rows-[0fr] opacity-0"
                    }`}
                  >
                    <div className="overflow-hidden">
                      <p className="px-5 pb-5 text-sm leading-relaxed text-foreground-600">{f.a}</p>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}